import { useEffect, useState } from "react";
import { api } from "@/api";

export function useCredits() {
  const [credits, setCredits] = useState(0);
  const [costs, setCosts] = useState({ catalogue_ai: 10, image_enhance: 1 });
  useEffect(() => {
    api.get("/exhibitor/profile").then(({ data }) => {
      setCredits(data.ai_credits);
      if (data.credit_costs) { setCosts(data.credit_costs); }
    }).catch(() => {});
  }, []);
  return { credits, setCredits, costs };
}
